
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { cloneDeep } from "apollo-utilities";
import CustomButton from "@/components/new/buttons/CustomButton.vue";

import FormGroup from "@/components/form/FormGroup.vue";
import UserLocationsMultiselect from "@/components/autocompleteMultiselects/UserLocationsMultiselect.vue";
// import TitlesMultiselect from "@/components/autocompleteMultiselects/TitlesMultiselect.vue";
import TitlesMultiselect from "@/components/autocompleteMultiselects/ContractorTagsSelector.vue";
import ContractorMultiSelector from "@/components/autocompleteMultiselects/ContractorsMultiSelector.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselect.vue";
import InputRangeFilter from "@/components/filters/InputRangeFilter.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import UserCityMultiselect from "@/components/autocompleteMultiselects/UserCityMultiselect.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputNew.vue";
import FormDatepicker from "@/components/form/FormDatepicker.vue";
import ContractorAdditionalFilters from "@/entities/scheduler/additionalFiltersInterfaces/ContractorAdditionalFilters";
import contractorViewFiltersTemplate from "@/data/filtersTemplates/scheduler/contractorViewFiltersTemplate";
import DateRange from "@/entities/scheduler/DateRange";
import moment from "moment";
import FormDateRangePicker from "@/components/form/FormDateRangePicker.vue";
import UIButton from "@/components/button/ui-button.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
@Component({
  components: {
    FormGroup,
    UserLocationsMultiselect,
    TitlesMultiselect,
    SkillsMultiselect,
    InputRangeFilter,
    UserCityMultiselect,
    ProfileCountrySelect,
    RegionInput,
    FormDateRangePicker,
    ContractorMultiSelector,
    UIButton,
    ModalFullScreen,
    CustomButton,
    FormDatepicker,
  },
})
export default class ContractorAdvancedFilter extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly shouldClearFilters!: boolean;
  filterFields: ContractorAdditionalFilters = cloneDeep(
    contractorViewFiltersTemplate
  );
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  selectedSkills: any[] = [];

  created(): void {
    this.$emit("appliedFiltersChanged", this.numberOfAppliedFilters);
  }

  //wip 3
  rangeStart: Date = new Date();
  // rangeEnd: Date = moment(this.rangeStart).add(1, "M").toDate();
  rangeEnd: Date = this.rangeStart;


  dateRangeFilter: string = null;

  @Watch("shouldClearFilters", { immediate: true })
  handleClearFilters(value: boolean): void {
    if (value === true) {
      this.clearFilters();
      this.$emit("filtersReset", cloneDeep(contractorViewFiltersTemplate));
    }
  }

  setSkills(skills: any[]): void {
    this.selectedSkills = skills;
  }

  get numberOfAppliedFilters(): any {
    const appliedFiltersQuantity = {
      countries: this.filterFields.countries.length ? 1 : 0,
      states: this.filterFields.states.length ? 1 : 0,
      cities: this.filterFields.cities.length ? 1 : 0,
      titles: this.filterFields.titles.length ? 1 : 0,
      skills: this.filterFields.skills.length ? 1 : 0,
      users: this.filterFields.users.length ? 1 : 0,
      rate: this.filterFields.minRate || this.filterFields.maxRate ? 1 : 0,
    };

    return Object.values(appliedFiltersQuantity).reduce(
      (prevValue, curValue) => {
        return prevValue + curValue;
      },
      0
    );
  }

  get countriesNames(): string[] {
    return this.filterFields.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.filterFields.states.map((state) => state.name);
  }

  get citiesNames(): string[] {
    return this.filterFields.cities.map((city) => city.name);
  }

  get titleNames(): string[] {
    return this.filterFields.titles.map((title) => title.name);
  }
  get getUsers(): any[] {
    return this.filterFields.users.map((title) => title.id);
    // return this.filterFields.names as any
  }

  applyFilters(): void {
    this.$emit("apply-filters", {
      countries: this.countriesNames,
      states: this.statesNames,
      cities: this.citiesNames,
      rangeStart: this.rangeStart,
      rangeEnd: this.rangeEnd,
      skills: this.filterFields.skills,
      minRate: this.filterFields.minRate,
      maxRate: this.filterFields.maxRate,
      titles: this.titleNames,
      users: this.getUsers
    });
  }
  clearFilters(): void {
    this.filterFields = cloneDeep(contractorViewFiltersTemplate);
    //wip 3
    this.rangeStart = new Date();
    // this.rangeEnd=  moment(this.rangeStart).add(1, "M").toDate();
    this.rangeEnd = this.rangeStart;

  }

  closeModal(): void {
    this.$emit("close");
  }
}
